import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";

/**
 * Generated class for the PopoverProductStatusPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-popover-cyclecount-details',
  templateUrl: 'popover-cyclecount-details.html',
})
export class PopoverCycleCountDetailsPage {

  array: string[] = [];
  title: string = '';
  isDragging: boolean = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              public viewCtrl: ViewController) {
    this.title = navParams.get('title');
    this.array = navParams.get('array');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PopoverProductStatusPage');
  }

  itemSelected(selectedItem: string) {
    if(!this.isDragging){
      this.viewCtrl.dismiss(selectedItem);
    } else {
      this.isDragging = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/popover-cyclecount-details/popover-cyclecount-details.ts